// main menu
$(document).ready(function(){


 $('.site-nav .site-nav--has-dropdown').hover(
  function () {
    $(this).find('.site-nav__dropdown .c-menu__link-container').children().first().addClass('active');
  },
  function () {
    $(this).find('.site-nav__dropdown .c-menu__link-container').children().first().removeClass('active');
  }
);

$('.site-nav__label-list-container').hover(function () {
  $('.site-nav__label-list-container').removeClass('active');
});



});




// Product toggle handler in product pages
$(document).ready(function(){
    $('.c-product__toggle:not(.active)').on('click', function (e) {
          // Prevent PageFly tab click from scrolling the page (many tabs are anchors)
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
    
          var scrollY = window.scrollY || window.pageYOffset || 0;
    
         
          if ($(this).closest('.g-tabs__nest').find('.g-tab').length > 0) {
            $tab = $(this).closest('.g-tabs__nest').find('.g-tab').eq($(this).index());
          } else {
            $tab = $(this).closest('.g-tabs').find('.g-tab').eq($(this).index());
          }
          
          $tab.triggerHandler('click');
          if (!$tab.hasClass('active') && !$tab.attr('aria-selected')) {
            $tab.trigger('click');
          }
    
          // Restore scroll position in case something still shifts it.
          requestAnimationFrame(function () {
            window.scrollTo(0, scrollY);
          });
    
          return false;
        });
    });



$(document).ready(function () {
    (function ($) {

        // Add owl carousel in cart page
        $('.owl-carousel.coupons').owlCarousel({
          animateOut: 'fadeOut',
          autoplaySpeed: 1200,
          loop: true,
          mouseDrag: true,
          touchDrag: true,
          items: 1.2,
          dots: false,
          autoplay: true,
          margin: 10,
          stagePadding: 0,
          autoplay: false
        });

   

    // mothers day carousel
    $('.owl-carousel.c-carousel').owlCarousel({
        center: true,
        items: 3,
        loop: true,
        margin: 10,
        nav: true,
        dots: true,
        dotsEach: true,
        startPosition: 1,
        responsive: {
          0: {
            items: 1,
            stagePadding: 20,
            startPosition: 0
          },
          600: {
            items: 3
          }
        }
    });

    // // IPL
    // $('.owl-carousel.c-duration').owlCarousel({
    //     center: true,
    //     items: 3,
    //     loop: true,
    //     margin: 10,
    //     nav: true,
    //     dots: true,
    //     dotsEach: true,
    //     startPosition: 1,
    //     // stagePadding: 100,
    //     responsive: {
    //       0: {
    //         items: 1,
    //         stagePadding: 20,
    //         startPosition: 0
    //       },
    //       600: {
    //         items: 3
    //       }
    //     }
    // });

       // Add carousel in nosttrimmer testimonial
      $('.owl-carousel.c-hairdryer__testimonial').owlCarousel({
        center: true,
        items: 1,
        loop: true,
        margin: 26,
        nav: true,
        dots: true,
        dotsEach: true,
        startPosition: 1,
        stagePadding: 260,
        responsive: {
          0: {
            items: 1,
            stagePadding: 20,
            margin: 10,
            startPosition: 0
          },
          600: {
            items: 1
          }
        }
    });


     $('.owl-carousel.c-testimonial').owlCarousel({
          center: true,
          items: 3,
          loop: true,
          margin: 10,
          nav: true,
          dots: true,
          dotsEach: true,
          startPosition: 1,
          responsive: {
            0: {
              items: 1,
              stagePadding: 20,
              startPosition: 0
            },
            600: {
              items: 3
            }
          }
      });


        // Apply coupon code on click coupon in cart page
        $('.c-cart__container').on('click', '.c-coupon__item', function(event){
          event.preventDefault();
          var code = $(this).attr("data-code");
          if (code) {
            window.discountOnCartProApp.applyCode(code)
          }
        })

      // Footer menu toggle in mobile view
$('.footer__links-title').on('click', function() {
  $(this).closest('.footer__links-item').toggleClass('active')
})
      
    })(jQuery);
});


$(document).ready(function(){
  $(".c-side__nav-trigger").on('click', function(event){
    event.stopPropagation();
    $(".c-side__nav").toggleClass('active');
    $(".c-overlay").toggle();
    $("body").toggleClass("active__sidenav");
  });
  
  $(document).on("click", navCloseHandler);
  
  $(".c-side__nav").on('click', function(event) {
    event.stopPropagation();
  });

  function navCloseHandler(event ){
    event.stopPropagation();
    $(".c-side__nav").removeClass('active');   
    $(".c-overlay").hide();
    $("body").removeClass("active__sidenav");
  }
});




// $(document).ready(function() {
//   $(function(){
//       let scrollHeight=500*2; 

//     if ($(window).width() < 767) {
//       scrollHeight=500*6; 
//     }
//       function playvideo(index){
//         $(`.c-animation__container2 .c-animation__content .bg-video-${ index } video`).trigger( 'play' ).parents(".item").css("opacity","1").siblings().css("opacity","0").find(".bg-video video").trigger( 'pause' )
//       }
     
//    function frame_part_11() {
//        playvideo(1)
//         var t1;
//        if ($(window).width() > 767) {
//             t1 = gsap.timeline()	   
//            .fromTo('.c-animation__container2 .c-animation__content .part-1 .text1',
//                   { "bottom": "-20%","opacity":"0" },               
//                   {"bottom": "0%", "opacity": "1", duration: .5, ease: "power1.in" })
//           .fromTo('.c-animation__container2 .c-animation__content .part-1 .text2',
//                   { "bottom": "-20%","opacity":"0" },
//                   {"bottom": "0%", "opacity": "1", duration: 1, ease: "power1.in" })  
//           .fromTo('.c-animation__container2 .c-animation__content .part-1 .content',
//             { "bottom": "-20%","opacity":"0" },
//             {"bottom": "0%", "opacity": "1", duration: 1, ease: "power1.in" })      
//           .to('.c-animation__container2 .c-animation__content .part-1',
//             {onReverseComplete:function(){ playvideo(1) } })
//        } else {
//           t1 = gsap.timeline()	   
//              .fromTo('.c-animation__container2 .c-animation__content .part-1 .text1',
//                   { "bottom": "-20%","opacity":"0" },               
//                   {"bottom": "0%", "opacity": "1", duration: .5, ease: "power1.in" })
//             .fromTo('.c-animation__container2 .c-animation__content .part-1 .text2',
//                   { "bottom": "-20%","opacity":"0" },
//                   {"bottom": "0%", "opacity": "1", duration: 1, ease: "power1.in" })  
            
//              .fromTo('.c-animation__container2 .c-animation__content .part-1 .content .content-item.content-item-1',
//                   { "bottom": "-20%","opacity":"0" },               
//                   {"bottom": "0%", "opacity": "1", duration: 1.5, ease: "power1.in" })
//             .fromTo('.c-animation__container2 .c-animation__content .part-1 .content .content-item.content-item-1',
//                     {"bottom": "0%", "opacity":"1"},
//                     {"bottom": "0%", "opacity":"1",duration:1.5})
//             .fromTo('.c-animation__container2 .c-animation__content .part-1 .content .content-item.content-item-1',
//                     {"bottom": "0%", "opacity":"1"},
//                     {"bottom": "20%", "opacity":0,duration:1.5})

//              .fromTo('.c-animation__container2 .c-animation__content .part-1 .content .content-item.content-item-2',
//                   { "bottom": "-20%","opacity":"0" },               
//                   {"bottom": "0%", "opacity": "1", duration: 1.5, ease: "power1.in" })
//             .fromTo('.c-animation__container2 .c-animation__content .part-1 .content .content-item.content-item-2',
//                     {"bottom": "0%", "opacity":"1"},
//                     {"bottom": "0%", "opacity":"1",duration:1.5})
//             .fromTo('.c-animation__container2 .c-animation__content .part-1 .content .content-item.content-item-2',
//                      {"bottom": "0%", "opacity":"1"},
//                     {"bottom": "20%", "opacity":0,duration:1.5})

//              .fromTo('.c-animation__container2 .c-animation__content .part-1 .content .content-item.content-item-3',
//                   { "bottom": "-20%","opacity":"0" },               
//                   {"bottom": "0%", "opacity": "1", duration: 1.5, ease: "power1.in" })
//             .fromTo('.c-animation__container2 .c-animation__content .part-1 .content .content-item.content-item-3',
//                     {"bottom": "0%", "opacity":"1"},
//                     {"bottom": "0%", "opacity":"1",duration:1.5})
//             .fromTo('.c-animation__container2 .c-animation__content .part-1 .content .content-item.content-item-3',
//                      {"bottom": "0%", "opacity":"1"},
//                     {"bottom": "20%", "opacity":0,duration:1.5})

//              .fromTo('.c-animation__container2 .c-animation__content .part-1 .content .content-item.content-item-4',
//                   { "bottom": "-20%","opacity":"0" },               
//                   {"bottom": "0%", "opacity": "1", duration: 1.5, ease: "power1.in" })
//             .fromTo('.c-animation__container2 .c-animation__content .part-1 .content .content-item.content-item-4',
//                     {"bottom": "0%", "opacity":"1"},
//                     {"bottom": "0%", "opacity":"1",duration:1.5})
//             .fromTo('.c-animation__container2 .c-animation__content .part-1 .content .content-item.content-item-4',
//                      {"bottom": "0%", "opacity":"1"},
//                     {"bottom": "20%", "opacity":0,duration:1.5})
            
//           .to('.c-animation__container2 .c-animation__content .part-1',
//             {onReverseComplete:function(){ playvideo(1) } })
//        }
	 
//        return t1;
//      }

//      let tl = gsap.timeline();
     
//         tl.add(frame_part_11());
     
//     ScrollTrigger.create({
//         trigger: ".c-animation__container2>div",
//         start: `center center`,
//         end: "+=" + scrollHeight,
//         scrub:true,
//         pin: true,
//         animation:tl
//     });
//    })  
// });


// $(document).ready(function() {
//   $(function(){
//       let scrollHeight=500*2; 

//     if ($(window).width() < 767) {
//       scrollHeight=500*6; 
//     }
//       // function playvideo(index){
//       //   $(`.c-animation__container2 .c-animation__content .bg-video-${ index } video`).trigger( 'play' ).parents(".item").css("opacity","1").siblings().css("opacity","0").find(".bg-video video").trigger( 'pause' )
//       // }
     
//     function frame_part_11() {
//       var t1;
    
//       t1 = gsap.timeline()
//       .fromTo('.c-animation__container .c-animation__content .part-1 .text1',
//             { "bottom": "-20%","opacity":"0" },               
//             {"bottom": "0%", "opacity": "1", duration: .5, ease: "power1.in" })
//       .fromTo('.c-animation__container .c-animation__content .part-1 .text2',
//               { "bottom": "-20%","opacity":"0" },
//               {"bottom": "0%", "opacity": "1", duration: 1, ease: "power1.in" })  
//       .fromTo('.c-animation__container .c-animation__content .part-1 .content',
//         { "bottom": "-20%","opacity":"0" },
//         {"bottom": "0%", "opacity": "1", duration: 1, ease: "power1.in" })      
//         return t1;
//     }

//     let tl = gsap.timeline();
//     tl.add(frame_part_11());
     
//     ScrollTrigger.create({
//         trigger: ".c-animation__container>div",
//         start: `center center`,
//         end: "+=" + scrollHeight,
//         scrub:true,
//         pin: true,
//         animation:tl
//     });


//    })  
// });